module.exports = __webpack_public_path__ + "img/274.d1ba2f7d.jpg";